import { createFileRoute } from '@tanstack/react-router';
import { TeamScreen } from '@/features/organisation/components/team-screen';

// FR-02 — écran équipe (gestion des membres, rôles, invitations).
export const Route = createFileRoute('/_app/settings/team')({
  component: TeamScreen,
});
